/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAccountSettings200ResponseSettingsInner
 */
export interface GetAccountSettings200ResponseSettingsInner {
    /**
     * 設定カテゴリー 200:メール通知設定
     * @type {string}
     * @memberof GetAccountSettings200ResponseSettingsInner
     */
    settingCategory: string;
    /**
     * 設定タイプ 201:興味あり通知
     * @type {string}
     * @memberof GetAccountSettings200ResponseSettingsInner
     */
    settingType: string;
    /**
     * 設定名
     * @type {string}
     * @memberof GetAccountSettings200ResponseSettingsInner
     */
    settingName: string;
    /**
     * 設定ステータス 0:OFF、1:ON
     * @type {number}
     * @memberof GetAccountSettings200ResponseSettingsInner
     */
    settingStatus: number;
}

/**
 * Check if a given object implements the GetAccountSettings200ResponseSettingsInner interface.
 */
export function instanceOfGetAccountSettings200ResponseSettingsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "settingCategory" in value;
    isInstance = isInstance && "settingType" in value;
    isInstance = isInstance && "settingName" in value;
    isInstance = isInstance && "settingStatus" in value;

    return isInstance;
}

export function GetAccountSettings200ResponseSettingsInnerFromJSON(json: any): GetAccountSettings200ResponseSettingsInner {
    return GetAccountSettings200ResponseSettingsInnerFromJSONTyped(json, false);
}

export function GetAccountSettings200ResponseSettingsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccountSettings200ResponseSettingsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'settingCategory': json['setting_category'],
        'settingType': json['setting_type'],
        'settingName': json['setting_name'],
        'settingStatus': json['setting_status'],
    };
}

export function GetAccountSettings200ResponseSettingsInnerToJSON(value?: GetAccountSettings200ResponseSettingsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'setting_category': value.settingCategory,
        'setting_type': value.settingType,
        'setting_name': value.settingName,
        'setting_status': value.settingStatus,
    };
}

